import type { RefObject } from "react"
import { useEffect, useState } from "react"

import { useLocation } from "react-router-dom"

export function useScrollPosition(ref: RefObject<HTMLElement | null>) {
  const [isAtBottom, setIsAtBottom] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = element
      const isBottom = Math.abs(scrollTop + clientHeight - scrollHeight) < 5

      if (isBottom !== isAtBottom) {
        setIsAtBottom(isBottom)
      }
    }

    element.addEventListener("scroll", handleScroll, { passive: true })
    handleScroll()

    return () => {
      element.removeEventListener("scroll", handleScroll)
    }
  }, [isAtBottom, ref, location.pathname])

  useEffect(() => {
    const element = ref.current
    if (!element) return

    element.scrollTop = 0
  }, [location.pathname, ref])

  return { isAtBottom }
}
